<div
  class="definition-list"
  [style.--sidebar-margin-bottom.px]="listMarginBottom"
>
  <ngx-simplebar
    [options]="simpleBarOptions"
    #scrollContainer
  >
    <div
      class="word-list"
      *ngIf="crosswordBoardConfig.crosswordSidebar === 'wordList'"
    >
      <ion-list
        class="parentlist"
        *ngFor="let wordList of wordLists"
        [id]="'wordlist-' + wordList.id"
      >
        <ion-list-header
          color="primary"
          *ngIf="wordList.name"
        >
          <ion-label>
            {{wordList.name | translate}}
          </ion-label>
        </ion-list-header>
        <div
          class="sublist"
          *ngFor="let subList of wordList.wordLists; let lastItem = last;"
          [class.selected]="['length','length&orientation', 'orientation'].indexOf(crosswordBoardConfig.splitWordList) !== -1 && subList === selectedSubList"
          [class.last]="lastItem"
          [id]="'wordlist-' + wordList.id + '-' + subList.id"
        >
          <ion-item-divider
            *ngIf="subList && subList.name"
            color="medium">{{subList.name | translate}}
          </ion-item-divider>
          <div
            class="sublist-words"
            *ngIf="subList && crosswordBoardConfig.crosswordSidebar === 'wordList'"
          >
            <div
              class="sublist-word-wrapper" *ngFor="let word of subList.words"
              cdkDropList
              [cdkDropListConnectedTo]="dropListIds"
              (cdkDropListExited)="dropListExited(subList.words, word)"
            >
            <span
              class="word-item puzzle-elevation-z3"
              [class.found]="highlightRightAndWrongEnabled ? word.correct : word.entered"
              [cdkDragDisabled]="highlightRightAndWrongEnabled ? word.correct : word.entered"
              cdkDrag
              [cdkDragData]="word"
              (cdkDragEnded)="onDragEnded(subList.words, word)"
            >
              {{word.word}}
            </span>
            </div>
          </div>
        </div>
      </ion-list>
    </div>


    <ion-list
      class="definition-list-inner"
      *ngIf="['definList', 'definAccordion'].indexOf(crosswordBoardConfig.crosswordSidebar) !== -1"
    >
      <div
        *ngFor="let splitConfig of split; let configIndex = index; let firstList = first;"
      >
        <ion-item-divider
          *ngIf="splitConfig.name"
          color="primary"
          [class.not-first-divider]="!firstList"
        >
          <ion-label>{{splitConfig.name | translate}}</ion-label>
        </ion-item-divider>

        <div
          class="definition-wrapper"
          *ngFor="let word of applyFilter(words, splitConfig.filter); let lastWord = last;"
          [id]="'definition-wrapper-'+word.index"
          [style.--definition-height.px]="definitionHeights[word.index]"
          [class.solved]="word.correct || !highlightRightAndWrongEnabled && word.completed"
          [class.accordion-expanded]="crosswordBoardConfig.crosswordSidebar === 'definList' || selectedWord === word"
        >

          <!--          For display-->
          <ion-item
            class="defin-item accordion-visible"
            [lines]="lastWord ? 'none' : 'full'"
            (click)="selectWord(word, $event)"
            [class.selected]="word === selectedWord"
            [id]="'word-'+word.index"
          >
            <ion-label
              class="defin-label"
              [class.ion-text-wrap]="crosswordBoardConfig.crosswordSidebar === 'definList' || selectedWord === word || lastSelectedWord === word"
            >
              <ion-text
                class="word-index"
                *ngIf="crosswordBoardConfig.fieldNumbers === 'show' && word.fieldNumber"
              >
                {{ word.fieldNumber }}
              </ion-text>
              <ion-text>{{ word.definTextLong || word.definText }}</ion-text>
            </ion-label>
          </ion-item>

          <!--          For height measurements-->
          <ion-item
            class="defin-item accordion-hidden"
            *ngIf="crosswordBoardConfig.crosswordSidebar === 'definAccordion'"
            [lines]="lastWord ? 'none' : 'full'"
            [id]="'word-expanded-'+word.index"
          >
            <ion-label class="defin-label ion-text-wrap">
              <ion-text
                class="word-index"
                *ngIf="crosswordBoardConfig.fieldNumbers === 'show' && word.fieldNumber"
              >
                {{ word.fieldNumber }}
              </ion-text>
              <ion-text>{{ word.definTextLong || word.definText }}</ion-text>
            </ion-label>
          </ion-item>
        </div>
      </div>
    </ion-list>

  </ngx-simplebar>
</div>
